// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-requests-scene .change-request-table-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
.change-requests-scene .filters-label {
  color: #2d5ab9;
  font-weight: 700;
}
.change-requests-scene .change-request-table {
  border-top: 1px solid #909090;
}
.change-requests-scene .change-request-row {
  display: grid;
  grid-template-columns: 1.2fr 1fr 1.4fr 1fr 1.3fr auto;
  gap: 16px;
  padding: 16px 8px;
  border-bottom: 1px solid #909090;
}
.change-requests-scene .actions {
  display: flex;
  gap: 12px;
  align-items: center;
}
.change-requests-scene .review-btn,
.change-requests-scene .dismiss-btn {
  min-width: 96px;
  height: 32px;
  border: 1px solid #2d5ab9;
  font-weight: 700;
  cursor: pointer;
}
.change-requests-scene .review-btn {
  background: #2d5ab9;
  color: #fff;
}
.change-requests-scene .dismiss-btn {
  background: #fff;
  color: #2d5ab9;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/ChangeRequests/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,cAAA;EACA,gBAAA;AADJ;AAIE;EACE,6BAAA;AAFJ;AAKE;EACE,aAAA;EACA,qDAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;AAHJ;AAME;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAJJ;AAOE;;EAEE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAQE;EACE,mBAAA;EACA,WAAA;AANJ;AASE;EACE,gBAAA;EACA,cAAA;AAPJ","sourcesContent":[".change-requests-scene {\n  .change-request-table-header {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 16px;\n  }\n\n  .filters-label {\n    color: #2d5ab9;\n    font-weight: 700;\n  }\n\n  .change-request-table {\n    border-top: 1px solid #909090;\n  }\n\n  .change-request-row {\n    display: grid;\n    grid-template-columns: 1.2fr 1fr 1.4fr 1fr 1.3fr auto;\n    gap: 16px;\n    padding: 16px 8px;\n    border-bottom: 1px solid #909090;\n  }\n\n  .actions {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n  }\n\n  .review-btn,\n  .dismiss-btn {\n    min-width: 96px;\n    height: 32px;\n    border: 1px solid #2d5ab9;\n    font-weight: 700;\n    cursor: pointer;\n  }\n\n  .review-btn {\n    background: #2d5ab9;\n    color: #fff;\n  }\n\n  .dismiss-btn {\n    background: #fff;\n    color: #2d5ab9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
